import React, { useState } from 'react';
import { formatCurrency } from '../utils/currencyFormatter';
import { PlusIcon, SearchIcon, FilterIcon } from 'lucide-react';
export function InvoiceList({
  invoices,
  onViewInvoice,
  setCurrentView,
  locale = 'en-US'
}) {
  const [searchTerm, setSearchTerm] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');
  const [filterMatching, setFilterMatching] = useState('all');
  const filteredInvoices = invoices.filter(invoice => {
    // Search term filter
    const matchesSearch = invoice.vendor.toLowerCase().includes(searchTerm.toLowerCase()) || invoice.invoiceNumber.toLowerCase().includes(searchTerm.toLowerCase()) || invoice.poReference && invoice.poReference.toLowerCase().includes(searchTerm.toLowerCase());
    // Status filter
    const matchesStatus = filterStatus === 'all' || invoice.status.toLowerCase() === filterStatus.toLowerCase();
    // Matching filter
    const matchesMatching = filterMatching === 'all' || invoice.matchingStatus === filterMatching;
    return matchesSearch && matchesStatus && matchesMatching;
  });
  return <div data-id="element-793">
      <div className="mb-8 flex justify-between items-center" data-id="element-794">
        <div data-id="element-795">
          <h2 className="text-2xl font-bold text-gray-900" data-id="element-796">Invoices</h2>
          <p className="mt-1 text-sm text-gray-500" data-id="element-797">
            View and manage all invoices
          </p>
        </div>
        <button onClick={() => setCurrentView('invoice-entry')} className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" data-id="element-798">
          <PlusIcon className="h-4 w-4 mr-1" data-id="element-799" />
          New Invoice
        </button>
      </div>
      {/* Search and Filters */}
      <div className="mb-6 bg-white p-4 shadow rounded-lg" data-id="element-800">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4" data-id="element-801">
          <div className="md:col-span-2" data-id="element-802">
            <label htmlFor="search" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-803">
              Search
            </label>
            <div className="relative rounded-md shadow-sm" data-id="element-804">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-805">
                <SearchIcon className="h-5 w-5 text-gray-400" data-id="element-806" />
              </div>
              <input type="text" name="search" id="search" className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md p-2 border" placeholder="Search by supplier, invoice number or PO reference" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-807" />
            </div>
          </div>
          <div data-id="element-808">
            <label htmlFor="status-filter" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-809">
              Status
            </label>
            <select id="status-filter" name="status-filter" className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md" value={filterStatus} onChange={e => setFilterStatus(e.target.value)} data-id="element-810">
              <option value="all" data-id="element-811">All Statuses</option>
              <option value="draft" data-id="element-812">Draft</option>
              <option value="pending" data-id="element-813">Pending</option>
              <option value="approved" data-id="element-814">Approved</option>
              <option value="in review" data-id="element-815">In Review</option>
            </select>
          </div>
          <div data-id="element-816">
            <label htmlFor="matching-filter" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-817">
              Matching Status
            </label>
            <select id="matching-filter" name="matching-filter" className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md" value={filterMatching} onChange={e => setFilterMatching(e.target.value)} data-id="element-818">
              <option value="all" data-id="element-819">All</option>
              <option value="matched" data-id="element-820">Fully Matched</option>
              <option value="partial" data-id="element-821">Partially Matched</option>
              <option value="none" data-id="element-822">Not Matched</option>
            </select>
          </div>
        </div>
      </div>
      {/* Invoices Table */}
      <div className="bg-white shadow overflow-hidden sm:rounded-md" data-id="element-823">
        <div className="overflow-x-auto" data-id="element-824">
          <table className="min-w-full divide-y divide-gray-200" data-id="element-825">
            <thead className="bg-gray-50" data-id="element-826">
              <tr data-id="element-827">
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-828">
                  Invoice
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-829">
                  Supplier
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-830">
                  Date
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-831">
                  Amount
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-832">
                  PO Reference
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-833">
                  Status
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-834">
                  Matching
                </th>
                <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-835">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-836">
              {filteredInvoices.length > 0 ? filteredInvoices.map(invoice => <tr key={invoice.id} className="hover:bg-gray-50" data-id="element-837">
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-838">
                      {invoice.invoiceNumber}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-839">
                      {invoice.vendor}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-840">
                      {invoice.invoiceDate}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-841">
                      {formatCurrency(invoice.amount, invoice.currency, locale)}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-842">
                      {invoice.poReference || '-'}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-843">
                      <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full 
                        ${invoice.status === 'Approved' ? 'bg-green-100 text-green-800' : invoice.status === 'Pending' ? 'bg-yellow-100 text-yellow-800' : invoice.status === 'Draft' ? 'bg-gray-100 text-gray-800' : 'bg-blue-100 text-blue-800'}`} data-id="element-844">
                        {invoice.status}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-845">
                      {invoice.matchingStatus === 'matched' ? <span className="text-green-600" data-id="element-846">✅ Matched</span> : invoice.matchingStatus === 'partial' ? <span className="text-yellow-600" data-id="element-847">⚠️ Partial</span> : <span className="text-red-600" data-id="element-848">❌ No match</span>}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-849">
                      <button onClick={() => {
                  onViewInvoice(invoice);
                  // You could navigate to a detail view here
                }} className="text-indigo-600 hover:text-indigo-900 mr-3" data-id="element-850">
                        View
                      </button>
                      {invoice.status === 'Pending' && <button onClick={() => setCurrentView('matching')} className="text-green-600 hover:text-green-900" data-id="element-851">
                          Match
                        </button>}
                    </td>
                  </tr>) : <tr data-id="element-852">
                  <td colSpan={8} className="px-6 py-4 text-center text-sm text-gray-500" data-id="element-853">
                    No invoices found matching your criteria
                  </td>
                </tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}